import * as React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';

export default class ConfirmationComponentimport extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            fullWidth: true,
            maxWidth: 'sm',
            open: false,
            message: ''
        };

        this.handleClose = this.handleClose.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleClose = () => {
        this.setState({ open: false });
        if(this.props.onCloseConfirmation){
            this.props.onCloseConfirmation();
        }
    };

    handleSubmit = () => {
        this.props.handleDialogSubmit();
    };
    
    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (nextProps.open !== this.props.open){
			this.setState({ open: nextProps.open, message: nextProps.message });
		}
    }
    render() {
        return (
            <Dialog
                fullWidth={this.state.fullWidth}
                hideBackdrop={true}
                maxWidth={this.state.maxWidth}
                open={this.state.open}
                aria-labelledby="max-width-dialog-title"
                className="applicationDialog"
            >

                <div className="dialogWrapper">
                    <div className="dialogHead">
                        <DialogTitle id="max-width-dialog-title" className="dialogTitle">Confirmation
                            {/* <Link color="primary" className="pull-right btn-close" onClick={this.handleClose}>
                                X
                            </Link> */}

                            <IconButton aria-label="Close" className="closeButton" onClick={this.handleClose}>
                                <CloseIcon />
                            </IconButton>

                            <hr className="HZDivider" />
                        </DialogTitle>
                    </div>

                    <div className="dialogContent">
                        <DialogContent>
                            {this.state.message}

                        </DialogContent>
                    </div>

                    <div className="dialogAction">
                        <DialogActions>
                            <Button color="primary" onClick={this.handleSubmit} className="btn-blue-primary" variant="outlined">
                                Yes
                            </Button>
                            <Button color="primary" onClick={this.handleClose} variant="outlined">
                                No
                            </Button>
                        </DialogActions>
                    </div>
                </div>
            </Dialog>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/common/notification/ConfirmationComponent.tsx